export default "__VITE_ASSET__fygDw5MK__"